export const CR_CANCELLED_STATUS_VALUE = 5
